<template>
    <!-- 订单详情 -->
    <div  class="Booking">
    <TopNavigation  class="topNavigation"></TopNavigation>
    <div class="typeArea">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/Order' }">我的订单</el-breadcrumb-item>
            <el-breadcrumb-item class="bread">订单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 订单详情内容 -->
        <div class="detail-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="订单详情" name="first">
                    <OrderDetails />
                </el-tab-pane>
                <el-tab-pane v-if="fileList.length>0" label="POD&EIR" name="fourth">
                    <div v-for="(item,index) in fileList" :key="index">
                        <div class="pdf_tit">
                            {{item.type==1?'POD':'EIR'}}
                        </div>
                        <div class="pdf">
                            <!-- <div class="pdf-t">{{item.file_type}}</div>
                            <div class="pdf-click">
                                {{item.file_name}}
                                <br>
                                点击下载查看文件内容
                            </div> -->
                            <div class="word">{{item.file_name}}</div>
                            <el-button type="text" @click="download(item)">下载</el-button>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="账单确认" name="third">
                    <div class="san">
                        <div class="tit">账单明细</div>
                        <el-table :data="billList">
                            <el-table-column prop="cost_name" label="费用名称"></el-table-column>
                            <el-table-column prop="cost_amount" label="单价"></el-table-column>
                        </el-table>
                    </div>
                    
                    <div class="zongji">
                        <div class="left">
                            <div>账单总计：
                                <span>
                                    USD {{totalMoney}}
                                </span>
                            </div>
                        </div>
                        <div class="right">
                            <!-- <el-button class="yulan">预览</el-button> -->
                            <el-button class="daochu" @click="daochu">导出</el-button>
                            <el-button class="biandong" @click="ConfirmBill">确认账单</el-button>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="订单留言" name="second">
                    <template #label>
                        <el-badge is-dot :hidden="hiddenBadge">
                            <span>订单留言</span>
                        </el-badge>
                    </template>
                    <LeaveWord :diaoyong='diaoyong' />
                </el-tab-pane>
            </el-tabs>

        </div>
    </div>
    <Bottom />
    </div>
</template>
    
<script>
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
import OrderDetails from "./OrderDetailsPage.vue";
import LeaveWord from "./LeaveWordPage.vue";
import { myOrdersDetail,billStatus,mjdmExportBill } from "@/api/api";
export default {
    components:{
        Bottom,
        TopNavigation,
        OrderDetails,
        LeaveWord,
    },
    data() {
        return {
            activeName: 'first',
            // 账单变动弹窗打开状态
            dialogTableVisible:false,
            canshu:{},
            headers:{
                token: localStorage.getItem('token')
            },
            // 账单确认
            billList:[],
            totalMoney:0,
            // 文件列表
            fileList:[],
            // 是否显示未读留言
            hiddenBadge:true,
            diaoyong:false,
        }
    },
    methods: {
        handleClick() {
            if(this.activeName == 'second'){
                this.hiddenBadge=true
                this.diaoyong=true
            }else{
                this.diaoyong=false
            }
        },
        async getDetails(){
            this.totalMoney = 0
            try {
                const res = await myOrdersDetail({
                id: this.$route.query.id
                },this.headers)
                if(res.code==1){
                    this.billList = res.data.bill
                    this.fileList = res.data.files

                    for (let i = 0; i < this.billList.length; i++) {
                       this.totalMoney += Number(this.billList[i].cost_amount)
                    }

                    if(res.data.user_liuyan_num>0){
                        this.hiddenBadge = false
                    }else{
                        this.hiddenBadge = true
                    }
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 确认账单
        async ConfirmBill(){
            try {
                const res = await billStatus({
                id: this.$route.query.id
                },this.headers)
                if(res.code==1){
                    this.$message({
                        type:'success',
                        message:'账单确认成功'
                    })
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 导出账单明细
        async daochu(){
          try {
              const res = await mjdmExportBill({
                  id: this.$route.query.id
              },this.headers)
              if(res.code==1){
                  // this.form = res.data
                  this.$message({
                      type:'success',
                      message:'导出成功'
                  })
                  const link = document.createElement('a');
                  link.href = res.data.url;
                  link.setAttribute('download', '');
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
              }else{
                  this.$message({
                      type:'error',
                      message:'导出失败'
                  })
              }
          } catch (error) {
              console.log(error,'失败');
          }
      },
        download(e) {
            const link = document.createElement('a');
            link.href = e.file_url;
            link.setAttribute('download', '');
            document.body.appendChild(link);
            link.click();
            document.bodyNaNpxoveChild(link);
        },
    },
    mounted(){
        this.canshu = this.$route.params
        if(this.canshu.id){
            sessionStorage.setItem('itemId',this.canshu.id)
        }
        this.getDetails()
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}


.el-breadcrumb{
    margin: 20px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .el-breadcrumb__inner is-link{
        color: pink;
    }
}

:deep(.el-breadcrumb){
    .el-breadcrumb__inner{
        color: #999999 !important;
    }
    .bread{
        span{
            color: #0073F5 !important;
        }
    }
}


.detail-content{
    background: #fff;
    margin-bottom: 92px;
    .el-tabs{
        padding: 10px 32px;
    }

    ::v-deep .el-tabs__item.is-active {
        color: #0073F5;//选中
    }
    
    ::v-deep .el-tabs__item:hover {
        color: #0073F5;//hover
        // cursor: pointer;
    }
    // 普通字体颜色
    ::v-deep .el-tabs__item {
        color: #606260;//悬浮
        // cursor: pointer;
        font-size: 18px;
    }

    // 下划线颜色
    ::v-deep .el-tabs__active-bar {
        background-color: #0073F5;
    }
    

    .san{
        .tit{
            font-size: 18px;

            margin-top: 24px;
            margin-bottom: 18px;
        }
    }

    .xiaoji{
        text-align: right;
        margin-top: 18px;
    }

    .zongji{
        height: 80px;
        background: #fff;
        // border-top: 1px solid#eee;

        display: flex;
        justify-content: space-between;
        align-items: center;

        margin-top: 32px;
        .left{
            margin-left: 32px;
            .yugu{
                display: flex;
                align-items: center;

                color: #999;
                font-size: 14px;

                margin-top: 8px;
                
            }
            span{
                color: #FE3300;
            }
        }

        .right{
            margin-right: 32px;

            .el-button{
                width: 100px;
                height: 40px;
                border-radius: 8px 8px 8px 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                font-style: normal;
                text-transform: none;
                border: 0;
            }
            .yulan{
                color: #0073F5;
            }
            .daochu{
                color: #0073F5;
                border: 1px solid #0073F5;
                margin-left: 16px;
            }
            .biandong{
                background: #0073F5;
                border-radius: 8px 8px 8px 8px;
                color: #fff;
                margin-left: 16px;
            }
        }
    }
}

.pdf_tit{
    font-size: 16px;
    color: #333333; 
    margin: 20px 0;
  }

  .pdf{
    // width: 400px;
    // height: 72px;
    // background: #F9F9F9;
    display: flex;
    align-items: center;
    cursor: pointer;

    .word{
        width: 300px;
        // background: pink;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .el-button{
        margin-left: 24px;
    }
    .pdf-t{
      width: 56px;
      height: 56px;
      background: #E64E3B;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      line-height: 56px;
      margin-left: 8px;
    }

    .pdf-click{
      font-size: 14px;
      color: #999999;
      margin-left: 12px;
    }
  }

.table{
    width: 100%;
    border-spacing: 0;


    margin-top: 4px;

    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
    }
    .first{
        padding-left: 24px;
        // width: 320px;
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;
        td{
            border-bottom: 1px solid #eee;
        }
        .queren{
            color: #0073F5;
            font-size: 14px;
            margin: 0;
        }

        .bohui{
            color: #FE3300;
            font-size: 14px;
            margin: 0;
        }

        .xie{
            color: #999;
        }
    }
    
}
</style>